import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ScenariosService from "@services/ScenariosService";

export const createScenario = createAsyncThunk(
  "scenario/create",
  async ({scenario}, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.createScenario({
        scenario,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const current = {
  name: "",
  mask: "",
  doctor_profile_id: null,
  product_ids: [],
  due_date: new Date().toISOString(),
  start_date: new Date().toISOString(),
  finish_date: new Date().toISOString(),
  purpose: "",
  objectives: "",
  key_messages: "",
  keywords: "",
  structure: "",
  script: "",
  phase: null,
  questions: "",
  evaluation_template_id: null,
  certification: false,
  badge: "",
};

const initialState = {
  target: current,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const createScenarioSlice = createSlice({
  name: "create-scenario",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    patchTarget(state, action) {
      state.target = {
        ...state.target,
        ...action.payload,
      };
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearCreateScenario() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createScenario.pending, (state) => {
        pendingState(state);
      })
      .addCase(createScenario.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(createScenario.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setIsChanged,
  setTarget,
  patchTarget,
  setError,
  setStatus,
  clearCreateScenario,
} = createScenarioSlice.actions;
export default createScenarioSlice.reducer;
